export const TABLE_SEARCH_DEBOUNCE_MS = 300;
export const DEFAULT_COLUMN_WIDTH = 180;
export const DEFAULT_MIN_COLUMN_WIDTH = 80;
export const CHECKBOX_COLUMN_WIDTH = 50;
export const DEFAULT_GROUP_MAX_HEIGHT = 400;
export const GROUP_BORDER_WIDTH = '3px';
// fit-content resize cap = widest cell content + CELL_HORIZONTAL_PADDING + slack.
export const FIT_CONTENT_MAX_SLACK = 100;
export const CELL_HORIZONTAL_PADDING = 32;
// Cells sampled by the widget DOM-intrinsic measure (columns are uniform per row).
export const FIT_CONTENT_SAMPLE_SIZE = 8;
// Expander cell holds px-4 (CELL_HORIZONTAL_PADDING = 32) + a 16px chevron; 56px
// leaves ~8px slack so the chevron is never clipped to ~0.
export const EXPANDER_MIN_WIDTH = 56;
// When row selection shares the expander cell it also holds a 16px checkbox + gap-2
// (8px): 32 + 16 (checkbox) + 8 (gap) + 16 (chevron) = 72px.
export const EXPANDER_MIN_WIDTH_WITH_SELECTION = 72;
